import axios from 'axios';

const fetchAndStoreCategories = async () => {
  const server_url = process.env.REACT_APP_API_URI;

  try {
    const response = await axios.get(`${server_url}/context/get-all-category`);
    const data = response.data.data || [];

    const existing = JSON.parse(localStorage.getItem('catId')) || [];
    const currentTime = new Date().getTime();
    const oneHour = 60 * 60 * 1000;

    // Filter out expired items (older than 1 hour)
    const validExisting = existing.filter(
      (item) => currentTime - item.timestamp < oneHour,
    );

    const newData = data.map((item) => ({
      title: item.title,
      _id: item._id,
      timestamp: currentTime,
    }));

    const merged = [
      ...validExisting,
      ...newData.filter(
        (newItem) =>
          !validExisting.some((oldItem) => oldItem._id === newItem._id),
      ),
    ];

    localStorage.setItem('catId', JSON.stringify(merged));
  } catch (error) {
    console.error('Error preloading categories:', error);
  }
};

export default fetchAndStoreCategories;
